<template>
  <el-row :gutter="30">

    <el-col :span="12">
      <data-form
        :entity="formData"
        :fields="{
          'version': {
            disabled: true
          },
          'commitHash': {
            disabled: true
          },
          'espVersion': {
            disabled: true
          },
          'ifVersion': {
            disabled: true
          },
          'ip': {
            disabled: true
          },
          'rssi': {
            disabled: true
          },
          'lastHeartbeat': {
            disabled: true,
            type: 'datetime'
          },
          'lastWifiReconnect': {
            disabled: true,
            type: 'datetime'
          },
          'lastMqttReconnect': {
            disabled: true,
            type: 'datetime'
          }
        }"
        :buttons="[]"
        :cancel="false"
      />
    </el-col>

    <el-col :span="12">
      <event-table
        :filters="eventFilters"
        :columns="['occured', '[T]name']"
        :showSearch="false"
      />
    </el-col>

  </el-row>
</template>

<script>
import EventTable from '../event/EventTable.vue'

export default {
  name: 'controller-diagnosis',
  props: {
    controller: {
      type: Object,
      required: true
    }
  },
  computed: {
    formData () {
      return {
        ...this.controller,
        rssi: this.controller.status === 'offline' ? 'offline' : `${this.controller.rssi} dB`
      }
    },
    eventFilters () {
      return {
        eventTypeId: [7004, 7005],
        controllerId: this.controller.id
      }
    }
  },
  components: {
    EventTable
  }
}
</script>


// WEBPACK FOOTER //
// ControllerDiagnosis.vue?46356114